export const environment = {
  production: false,
  apiUrl: 'https://sportiq-licence-api.digi4dev.ma',
  baseDomain: 'sportiq-licence.digi4dev.ma',
  devFederationSlug: 'frmtt',
  version: '1.0.9',
  hide_statistique: false,
  action_block: false
};
